import { CreateFocusCss } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import type { PopoverCloseProps } from '..'

export default (config: {
  tokens: Tokens
  props: Partial<PopoverCloseProps>
}) => {
  const { tokens, props } = config
  const { dark, scrim } = props

  return {
    default: {
      wrap: {
        ...(scrim && {
          // TODO: @ds/tokens replace with tokens from after next bump.
          backgroundColor: dark
            ? 'rgba(30, 24, 30, 0.8)'
            : 'rgba(255, 255, 255, 0.8)',
          borderRadius: '2px',
        }),

        ...(dark && {
          button: {
            '&:hover': {
              backgroundColor: tokens.dark.ctaBgColorTertiaryHover,
            },
            '&:active': {
              backgroundColor: tokens.dark.ctaBgColorTertiaryActive,
            },
            ...CreateFocusCss({
              outlineColor: tokens.iconColorInverse,
            }),

            svg: {
              fill: tokens.iconColorInverse,
            },
          },
        }),
      },
    },
  } as const
}
